// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config from "../../../../../../Config.bs.js";
import * as TicketsRepo from "./TicketsRepo.bs.js";
import * as DummyTicketsRepo from "./DummyTicketsRepo.bs.js";

function getTicketsRepo(param) {
  if (Config.Env.env === "development") {
    return {
            fetchTicketInfo: DummyTicketsRepo.TicketsRepo.fetchTicketInfo,
            fetchTicketIssues: DummyTicketsRepo.TicketsRepo.fetchTicketIssues,
            fetchTicketActions: DummyTicketsRepo.TicketsRepo.fetchTicketActions,
            raiseTicket: DummyTicketsRepo.TicketsRepo.raiseTicket,
            fetchTickets: DummyTicketsRepo.TicketsRepo.fetchTickets,
            fetchTicket: DummyTicketsRepo.TicketsRepo.fetchTicket,
            updateTicket: DummyTicketsRepo.TicketsRepo.updateTicket
          };
  } else {
    return TicketsRepo.TicketsRepo;
  }
}

export {
  getTicketsRepo ,
  
}
/* Config Not a pure module */
